import { cn } from "@repo/utils";
import { useSharedListSelection } from "~/pages/dashboard/task/ui/list-selection-context";

type Props = {
  text: string | React.ReactNode;
  subtitle?: string;
  headerClassName?: string;
  textClassName?: string;
  totalCount?: number;
};

export const Title = ({ text, subtitle, headerClassName, textClassName, totalCount }: Props) => {
  const { activeList } = useSharedListSelection();

  const displaySubtitle = subtitle || activeList?.name || null;

  return (
    <div className={cn("flex w-full items-end justify-between px-4 py-3", headerClassName)}>
      <div className="flex flex-col">
        <h1 className={cn("text-base font-bold", textClassName)}>{text}</h1>
        {displaySubtitle && <p className="text-xs">{displaySubtitle}</p>}
      </div>
      {totalCount !== undefined && <p className="text-xs">{totalCount} Items</p>}
    </div>
  );
};
